import _ from "lodash"
import {ValueType} from "../../shared/enums/valueType"
import {AnalyteComparison} from "../../shared/enums/analyteComparison"
import {ExportFileType} from "../../shared/enums/exportFileType"
import {MatrixType} from "../../shared/enums/matrixType"
import Filter from "./filter"
import Matrix from "./matrix"
import ComponentSwitch from "./componentSwitch"
import SwitchableValue from "./switchableValue"
import {Item} from "../../core/models/Item"

export class RefDbDataContext {
    exportFileType: any

    includesSummary: any

    log2Transformation: boolean

    categorizeDetectability: any

    sumUpMetaboliteClasses: any

    filters: Filter[]

    species: string

    assay: SwitchableValue<string[]>

    material: string

    projects: SwitchableValue<string[]>

    metabolites: SwitchableValue<Item[]>

    classes: SwitchableValue<string[]>

    matrixType: Matrix

    ownSamples: boolean

    showHmdbId: boolean

    index: number

    totalSampleNumber?: number

    switches: ComponentSwitch[]

    public static of(
        index: number,
        assayValue: string[],
        switches: ComponentSwitch[]
    ): RefDbDataContext {
        return {
            index,
            assay: SwitchableValue.enable(assayValue),
            projects: SwitchableValue.disable([]),
            switches: _.cloneDeep(switches),
            classes: SwitchableValue.disable([]),
            metabolites: SwitchableValue.disable([]),
            filters: [],
        } as RefDbDataContext
    }
}

export default interface DisplayDataContext {
    plateRunIds: string[]
    unknownsOnly: boolean

    valueType: ValueType
    matrixType: MatrixType
    showClass: boolean
    displayClass: string
    showBioId: boolean
    bioId: string
    sortColumnsBy: AnalyteComparison
    showAnalyticalDetails: boolean
    showCalibrationMetabolite: boolean
    showCalibratorsUsage: boolean
    showCalibrationEquation: boolean
    displayUnit: string

    plateSource: string
    sampleSource: string
    sampleSourceConfiguration: SampleSourceConfiguration[]
    method: string
    logTransformData: boolean
    logTransformDataMethod: string
    creatinineNormalization: boolean
    subtractMedianConcentration: boolean

    exportFileType: ExportFileType
    exportOptions: {
        [key in ExportFileType]: ExportOptions
    }

    replaceValuesOf: ReplaceValuesOf[]
}

export interface SampleSourceConfiguration {
    plateRun: string
    sampleBarCode: string
}

export interface ReplaceValuesOf {
    flag: boolean
    label: string
    backgroundColor: string
    replaceWithText: string
}

export interface ExportOptions {
    transposeValues?: boolean
    addComments?: boolean
    exportStatus?: boolean
    exportAllValueTypes?: boolean
}

export const displayUnitCrea = "µmol Metabolite/mmol Creatinine"
export const displayUnituM = "µM"
